function o(e) {
  return {
    headerComponent: "headerCheckBox",
    pinned: "left",
    cellRenderer: "cellSelection",
    width: 60,
    colId: "GRID_ACTION",
    headerComponentParams: e,
    lockPosition: !0,
    resizable: !1,
    sortable: !1
  };
}
function r(e, n) {
  return {
    ...n,
    headerComponent: "columnSort",
    pinned: "right",
    lockPosition: !0,
    width: 40,
    colId: "COLUMN_SORT",
    headerClass: "column-sort-header",
    resizable: !1,
    sortable: !1,
    cellRendererParams: e,
    minWidth: 40,
    cellRenderer: e != null && e.quickOperations ? "quickOperations" : null
  };
}
function t(e, n) {
  return {
    ...n,
    pinned: "right",
    lockPosition: !0,
    width: 40,
    colId: "QUICK_OPERATIONS",
    cellRendererParams: e,
    cellRenderer: "quickOperations",
    resizable: !1,
    sortable: !1,
    minWidth: 40
  };
}
export {
  r as getColumnDSortColDef,
  t as getQuickOperationsColDef,
  o as getSelectionColDef
};
//# sourceMappingURL=util.js.map
